var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRelationAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 4.33337H2.16663V20.5834H10.2916L13 23.2917L15.7083 20.5834H23.8333V4.33337Z",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C14.4957 13 15.7083 11.7875 15.7083 10.2917C15.7083 8.79594 14.4957 7.58337 13 7.58337C11.5042 7.58337 10.2916 8.79594 10.2916 10.2917C10.2916 11.7875 11.5042 13 13 13Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 17.3333C17.875 14.9401 15.6924 13 13 13C10.3076 13 8.125 14.9401 8.125 17.3333",
    stroke: "currentColor",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelationAppointment);
export default __webpack_public_path__ + "static/media/icon-relation-appointment.01f66a6ddf129fe86f974009ddd28550.svg";
export { ForwardRef as ReactComponent };